module.exports = __webpack_public_path__ + "img/pk_watch.819ecb96.png";